'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voter-group-show-ss.routes';

const moment = require('moment');

export class VoterGroupShowSsComponent {
  constructor(Auth, PropertyService, WebAccessService, dialogs, $scope, $uibModal,
              DTOptionsBuilder, DTDefaultOptions, DTState, SettingsService, $stateParams,
              VoterGroupsService, $window, $timeout, DTColumnBuilder) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;

    this.id = $stateParams.id;
    this.PropertyService = PropertyService;
    this.WebAccessService = WebAccessService;
    this.VoterGroupsService = VoterGroupsService;
    this.filteredData = [];
    this.data = [];

    this.ssInitReady3 = 0;

    this.webAccessesIds = [];
    WebAccessService.queryIds(data => {
      this.webAccessesIds = data.filter(o => o.contact).map(o => o.contact);
    });

    this.valueMap = {
      address: {},
      primaryOwnerHtml: {},
      voterHtml: {},
      buildingUnit: {}
    };

    this.stats = {};

    this.dialogs = dialogs;

    this.isCollapsed = true;

    this.chartData = {
      'dist': [0,0,0],
      'asn': [[0],[0],[0]]
    };
    this.chartLabels = {
      'dist': ["E-Voter","Blocked","Paper Voter"],
      'asn': ["Community"]
    };
    this.chartColors = {
      'dist': ['#2ECC71','#C70039','#00008b'],
      'asn':  ['#2ECC71','#C70039','#00008b']
    };

    this.chartSeries = {
      'asn': ["E-Voter","Blocked","Paper Voter"]
    };

    this.chartOptions = {
      'dist': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Voting Preference Distribution'
        },
        animation: false
      },
      'asn': {
        title: {
          display: true,
          text: 'Voting Preference Distribution per Association'
        },
        animation: false,
        plugins: {
          stacked100: { enable: true }
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    };

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideUseBldgUnit = ssDT && ssDT.voterGroups && ssDT.voterGroups.useBldgUnit;

      SettingsService.getByName({name: 'client'}, settings => {
        this.optInOutRequired = settings.data.optInOut && settings.data.optInOut.required;
        if (this.optInOutRequired) {
          this.optInOutSettings = settings.data.optInOut;
        }

        this.weightVisible = settings.data.weightVisible;
        this.hasBuildingNo = settings.data.buildingNoVisible;

        this.defaultOrder = (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'];
        if (this.serverSideUseBldgUnit)
          this.defaultOrder = [0, 'asc'];

        let schemaName = (this.weightVisible) ? "evoting" : "evoting-no-weight";
        this.eVotingSchema = require('../../../components/schemas/' + schemaName + ".json");

        this.eVotingSchema.properties.voter["x-schema-form"].type = "entitylookup-nodropdown"; // for SS contact lookup

        this.templateAddressLabels = settings.data.templateAddressLabels;
        this.templateCoverLetter = settings.data.templateCoverLetter;

        let that = this;

        this.dtColumns = [];

        if (this.serverSideUseBldgUnit)
          this.dtColumns.push(DTColumnBuilder.newColumn("customFields.buildingUnit").withTitle('Bldg-Unit').withOption('width', '3%'));
        else if (this.hasBuildingNo) {
          this.dtColumns.push(DTColumnBuilder.newColumn("buildingNo").withTitle('Bldg#').withOption('width', '3%'));
          this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
        } else {
          this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
        }

        this.dtColumns.push(DTColumnBuilder.newColumn("address").withTitle('Address').withOption('width', '20%'));
        //this.dtColumns.push(DTColumnBuilder.newColumn("primaryOwner").withTitle('Primary Owner').withOption('width', '15%'));

        this.dtOptionsSS = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('order', this.defaultOrder)
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredData = result.data;

              this.stats.all = result.recordsTotal;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtAll').DataTable().columns.adjust();
              }, 0);
            })
          });

        this.dtOptionsSSEV = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('order', this.defaultOrder)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            params.view = "evoter";

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredDataEV = result.data;

              this.stats.evoter = result.recordsTotal;
              this.chartData.dist[0] = this.chartData['asn'][0][0] = this.stats.evoter;

              this.ssInitReady2 = true; // delays fetch of paaper voter, blocked and no-voters as the base data is cached now on serveer side
              this.ssInitReady3++;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtEVoter').DataTable().columns.adjust();
              }, 0);
            })
          });

        this.dtOptionsSSPV = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('order', this.defaultOrder)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            params.view = "papervoter";

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredDataPV = result.data;

              this.stats.papervoter = result.recordsTotal;
              this.chartData.dist[2] = this.chartData['asn'][2][0] = this.stats.papervoter;

              this.ssInitReady3++;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtPaperVoter').DataTable().columns.adjust();
              }, 0);
            })
          });

        this.dtOptionsSSBL = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('order', this.defaultOrder)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            params.view = "blocked";

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredDataBL = result.data;

              this.stats.blocked = result.recordsTotal;
              this.chartData.dist[1] = this.chartData['asn'][1][0] = this.stats.blocked;

              this.ssInitReady3++;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtBlocked').DataTable().columns.adjust();
              }, 0);
            })
          });

        this.dtOptionsSSNV = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('order', this.defaultOrder)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            params.view = "novoter";

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredDataNV = result.data;

              this.stats.novoter = result.recordsTotal;

              this.ssInitReady3++;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtNoVoter').DataTable().columns.adjust();
              }, 0);
            })
          });

        this.dtOptionsSSNA = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          //.withOption('stateSave', true)
          //.withOption('stateSaveCallback', DTState.save())
          //.withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('order', this.defaultOrder)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit",
                "contacts[].contact.company", "voter.company",
                "contacts[].contact.firstName", "contacts[].contact.lastName", "contacts[].contact.lastName, contacts[].contact.firstName",
                "voter.firstName", "voter.lastName", "voter.lastName, voter.firstName"];
            }

            params.view = "noaccess";

            that.VoterGroupsService.getWithDataSS({id: that.id}, params, result => {

              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.filteredDataNA = result.data;

              this.stats.noaccess = result.recordsTotal;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              });

              that.$timeout(_=>{
                $('#dtNoAccess').DataTable().columns.adjust();
              }, 0);
            })
          });


        this.ssInitReady = true;
      });


      this.VoterGroupsService.get({id: this.id}, group => {
        this.group = group;
      });

    });

    //DTDefaultOptions.setLoadingTemplate( '<datatable-loading-placeholder columns="Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant" />');

    //this.refreshData();
  }

  buildValueMap(data, highlight, searchTerms) {
    data.forEach(ppty => {
      this.valueMap.address[ppty._id] = this.getAddress(ppty);

      this.valueMap.primaryOwnerHtml[ppty._id] = this.getPrimaryOwner(ppty.contacts);
      this.valueMap.voterHtml[ppty._id] = this.getComposedName(ppty.eVoting.voter);

      if (ppty.customFields && ppty.customFields.buildingUnit)
        this.valueMap.buildingUnit[ppty._id] = ppty.customFields.buildingUnit;

      if (highlight && searchTerms && searchTerms.length) {
        searchTerms.sort(function(a, b) {
          return b.length - a.length;
        });

        var regexFirst = new RegExp(searchTerms[0], 'i');
        var regexAll = new RegExp('(' + searchTerms.join('|') + ')', 'gi');

        if (this.valueMap.primaryOwnerHtml[ppty._id])
          this.valueMap.primaryOwnerHtml[ppty._id] = this.valueMap.primaryOwnerHtml[ppty._id].replace(regexAll, '<b>$&</b>');

        if (this.valueMap.voterHtml[ppty._id])
          this.valueMap.voterHtml[ppty._id] = this.valueMap.voterHtml[ppty._id].replace(regexAll, '<b>$&</b>');

        this.valueMap.address[ppty._id] = this.valueMap.address[ppty._id].replace(regexFirst, '<b>$&</b>');

        if (this.valueMap.buildingUnit[ppty._id])
          this.valueMap.buildingUnit[ppty._id] = this.valueMap.buildingUnit[ppty._id].replace(regexFirst, '<b>$&</b>');
      }
    });
  }

  adjustColumns(tableId) {
    this.$timeout(_=>{
      $('#'+tableId).DataTable().columns.adjust();
    }, 0);
  }

  filterData() {
    this.filteredData = this.data;
    this.rawFilteredData = angular.copy(this.filteredData);
  }

  openReportFilterModal(report) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reportFilterModal',
      resolve: {
        config: function() {
          return report
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }

  printLabels() {
    this.openReportFilterModal({
      report: 'voter-group-labels-paper-voter',
      template: this.templateAddressLabels,
      voterGroupId: this.id,
      title: 'Address Labels for Paper Voters',
      icon: 'th'
    })
  }

  printLetters() {
    this.openReportFilterModal({
      report: 'voter-group-cover-letter-paper-voter',
      template: this.templateCoverLetter,
      voterGroupId: this.id,
      title: 'Cover Letter for Paper Voters',
      icon: 'file-text-o'
    })
  }


  openEFormResultModal(eFormResultId) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormResultModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.optInOutSettings.optInForm,
            eFormResultId: eFormResultId
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );
  }

  editVoting(property) {
    var that = this;

    let eVoting = {};
    if (property.eVoting && property.eVoting.voter) {
      eVoting = angular.copy(property.eVoting);
      eVoting.voter = eVoting.voter._id;
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'schemaFormModal',
      resolve: {
        config: function() {
          return {
            title: "Voting",
            icon: "check-square-o",
            model: eVoting,
            schema: that.eVotingSchema,
            dependsOn: ["contact:" + eVoting.voter]
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (editedEVoting) {
        property.eVoting = editedEVoting;

        that.PropertyService.update({id: property._id}, property, _ => {
          that.VoterGroupsService.updateCache({id: that.id}, property, _ => {
            //that.refreshData();
            that.$timeout(_=> {
              ["dtAll", "dtEVoter", "dtPaperVoter", "dtBlocked", "dtNoVoter"].forEach(dtId => {
                $('#' + dtId).DataTable().ajax.reload(null,false); // user paging not reset
              });
            },100);

          });
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );
  }

  hasWebAccess(voter) {
    return this.webAccessesIds.includes(voter._id);
  }

  getComposedName(contact) {
    if (!contact)
      return "-";

    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getAddress(property) {
    try {
      let address = property.address.street;

      if (property.address.city && property.address.state && property.address.zip) {
        address += `, ${property.address.city} ${property.address.state}, ${property.address.zip}`;
      } else if (property.address.city) {
        address += `, ${property.address.city}`;
      } else if (property.address.state && property.address.zip) {
        address += `, ${property.address.state}, ${property.address.zip}`;
      }

      return address;
    } catch (e){
      return "-";
    }
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getActiveTenantId(contacts) {
    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant) // No Other Owner
      return 0;
    else if (!activeTenant.contact || !activeTenant.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return activeTenant.contact._id;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getActiveTenant(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant)
      return "-";

    return this.getComposedName(activeTenant.contact);
  }

}

export default angular.module('conduu.voterGroupShowSS', [uiRouter])
  .config(routes)
  .component('voterGroupShowSs', {
    template: require('./voter-group-show-ss.html'),
    controller: VoterGroupShowSsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voter-group/voter-group-show-ss/voter-group-show-ss.component.js